import { render, staticRenderFns } from "./LmProviders.vue?vue&type=template&id=67980a06"
import script from "./LmProviders.vue?vue&type=script&lang=js"
export * from "./LmProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports